import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { StudyReportReverseReason } from '../../../model/study-report-reverse-reason';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { NotificationToastService } from '../../../services/notification-toast.service';
import { StudyReportReverse } from '../../../model/study-rerport-reverse';
import { StudyReportService } from '../../../services/study-report/study-report.service';

@Component({
  selector: 'study-report-reverser-reason-dialog',
  templateUrl: 'study-report-reverser-reason-dialog.component.html',
  styleUrls: ['./study-report-reverser-reason-dialog.component.css']
})
export class StudyReportReverserReasonDialogComponent implements OnInit {

  form: FormGroup;
  studyReportReverseReasons: StudyReportReverseReason[] = [];

  constructor(
    public dialogRef: MatDialogRef<StudyReportReverserReasonDialogComponent>,
    private studyReportService: StudyReportService
    , private formBuilder: FormBuilder
    , private notificationToastService: NotificationToastService
    , @Inject(MAT_DIALOG_DATA) public data: number) {

    this.form = this.formBuilder.group({
      Observations: [''],
      StudyReportReverseReason: [null, Validators.required],
      StudyReportId: [this.data],
    });
  }

  get f() { return this.form.controls; }

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  async save() {
    try {
      if (!this.form.invalid) {
        const studyReportReverse = <StudyReportReverse>this.form.getRawValue();
        if (await this.studyReportService.studyReportReverse(studyReportReverse)) {
          this.dialogRef.close(true);
        }
      }
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Cancelación de turno');
    }
  }

  async ngOnInit() {
    try {
      this.studyReportReverseReasons = await this.studyReportService.getStudyReportReverseReasons();
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Revertir informe');
    }
  }
}
